import { render } from "./StructureSelect.vue?vue&type=template&id=05885c4a"
import script from "./StructureSelect.vue?vue&type=script&lang=js"
export * from "./StructureSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__